import { useContext } from 'react';
import { TooltipContext, type ChartTooltip } from './context';

/** Access the chart tooltip singleton. Must be under <TooltipProvider>. */
export function useChartTooltip(): ChartTooltip {
  const ctx = useContext(TooltipContext);
  if (!ctx) {
    throw new Error('useChartTooltip must be used within <TooltipProvider>');
  }
  return ctx;
}
